import { gql } from 'graphql-request';

export const SEND_TO_SUUNTO = gql`
  query SendToSuunto($klass: String!, $id: ID!) {
    sendToSuunto(klass: $klass, id: $id)
  }
`;
